import { featureCollection, lineString } from '@turf/helpers';
import { COLOR_MAP_ROUTE } from '@alltrails/denali/tokens';
import { useGetUserCustomRouteQuery } from '../../redux/customRoutesApi';
import PolylineSource from '../Polyline/PolylineSource';
import { LngLat } from '../../types/Geo';
import { getLineColor, getLineOutlineColor } from '../../utils/customRoutes/colors';
import { CustomRouteDetails, CustomRouteSegment, CustomRoutePath } from '../../types/CustomRoute';

type ActiveRoutePolylinesProps = {
  mapIds: number[];
};

const ensurePoints = (path: CustomRoutePath) => path.points && path.points.length > 0;

function getRouteFeatures(route: CustomRouteDetails, mapId: number | undefined) {
  if (!route?.segments) return [];
  return route.segments.flatMap((segment: CustomRouteSegment) =>
    segment.paths.filter(ensurePoints).map((path: CustomRoutePath) =>
      lineString(
        (path.points as LngLat[]).map(([lat, lng]) => [lng, lat]),
        {
          lineColor: getLineColor(segment.color || COLOR_MAP_ROUTE),
          lineOutlineColor: getLineOutlineColor(segment.color || COLOR_MAP_ROUTE),
          mapId
        }
      )
    )
  );
}

const ActiveRoutePolylines = ({ mapIds }: ActiveRoutePolylinesProps) => {
  // Use the new bulk query
  const { data, error, isLoading } = useGetUserCustomRouteQuery(mapIds, { skip: !mapIds.length });

  if (error) {
    console.error('Failed to fetch routes:', error);
  }

  if (isLoading || !data || mapIds.length == 0) return null;

  // Aggregate all features
  const features = data.flatMap(({ route }) => getRouteFeatures(route, route.id));

  if (!features.length) return null;

  return <PolylineSource data={featureCollection(features)} uniqueId="active-user-custom-polylines" hasSourcePaint={true} />;
};

export default ActiveRoutePolylines;
